import { API_URLS } from '../constants/apiUrls';
import { ICOMMENTS } from '../interfaces/commentsReq';
import { latLon } from '../constants/constant';
import axiosClient from './axiosClient';
import axios from 'axios';
import { IMyAvailabilityPayload } from '../type/myAvailabilityPayload';

const calenderApi = {
  getWeatherDetails: ( defaultLat: number , defaultLon: number) => {
    return axios.get(
      `${process.env.REACT_APP_WEATHER_URL}${API_URLS.WEATHER_URL}?key=${process.env.REACT_APP_API_KEY_WEATHER}&q=${defaultLat},${defaultLon}&days=3`,
    );
  },

  getCalendarDetails: (ownerId: number, date: string) => {
    return axiosClient.get(
      `${API_URLS.COMMENTS}?ownerId=${ownerId}&date=${date}`,
    );
  },

  addComment: (payload: ICOMMENTS) => {
    return axiosClient.post(`${API_URLS.POSTCOMMENTS}`, payload);
  },

  getBookingDetailsOrderByDate: (
    ownerId: number,
    rateId: number,
    fromDate: string,
    toDate: string,
  ) => {
    return axiosClient.get(
      `${API_URLS.BOOKINGS_DATA}?ownerId=${ownerId}&rateId=${rateId}&fromDate=${fromDate}&toDate=${toDate}`,
    );
  },

  getCalendarDetailsByDate: (
    fromDate: string,
    rateId: number,
    ownerId: number,
    toDate: string,
  ) => {
    return axiosClient.get(
      `${API_URLS.CALENDER_DETAILS}?fromDate=${fromDate}&rateId=${rateId}&ownerId=${ownerId}&toDate=${toDate}`,
    );
  },

  getCalendarAvailabilityStatus: () => {
    return axiosClient.get(`${API_URLS.CALENDER_AVAILABILITY_STATUS}`);
  },

  updateCalendarAvailabilityStatus: (payload: IMyAvailabilityPayload[]) => {
    return axiosClient.put(
      `${API_URLS.CALENDER_UPDATE_AVAILABILITY_STATUS}`,
      payload,
    );
  },

  getAvailabiltyforStaff: (
    staffId: number,
    fromDate: string,
    toDate: string,
  ) => {
    return axiosClient.get(
      `${API_URLS.CALENDER_UPDATE_AVAILABILITY_STATUS}?staffId=${staffId}&fromDate=${fromDate}&toDate=${toDate}`,
    );
  },

  getAvailabilityComments: (opDate: string, ownerId: number, days: number) => {
    return axiosClient.get(
      `${API_URLS.AVAILABILITY_COMMENTS}?opDate=${opDate}&ownerId=${ownerId}&days=${days}`,
    );
  },
};

export default calenderApi;
